var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Flex from "../templates/flex";
import { Text } from "../typography";
import { Icon } from "../icon";
var rotateMap = { right: 1, bottom: 2, left: 3 };
var Container = function (_a) {
    var children = _a.children, align = _a.align, _b = _a.margin, margin = _b === void 0 ? [1] : _b, _c = _a.background, background = _c === void 0 ? "tooltip" : _c, rest = __rest(_a, ["children", "align", "margin", "background"]);
    return (React.createElement(Flex, { column: align === "top", columnReverse: align === "bottom", rowReverse: align === "right", margin: margin },
        React.createElement(Flex, __assign({ background: background, padding: [1, 2], round: true, column: true }, rest), typeof children === "string" ? React.createElement(Text, { color: "bright" }, children) : children),
        align && (React.createElement(Icon, { name: "triangle", alignSelf: "center", color: background, rotate: rotateMap[align], height: "8px", width: "8px", "data-testid": "drop-arrow" }))));
};
export default Container;
